export type CourseCategoryShowView = {
  name: CourseCategoryType;
};

export const COURSE_CATEGORY = {
  Design: 'デザイン',
  Writing: 'ライティング',
  Marketing: 'マーケティング',
  Branding: '広報・ブランディング',
  Video: '動画',
  Business: 'ビジネス',
  Photograph: '写真',
  Introduction: 'はじめに',
} as const;

export type CourseCategoryType = typeof COURSE_CATEGORY[keyof typeof COURSE_CATEGORY];
